import { ArrowBackIcon } from '@chakra-ui/icons'
import { Box, Drawer, DrawerContent, DrawerOverlay, IconButton } from '@chakra-ui/react'
import React from 'react'

interface DrawerWrapperProps {
  onClose: () => void
  onBack?: () => void
  children: React.ReactNode
  isVisible: boolean
}

const DrawerWrapper: React.FC<DrawerWrapperProps> = ({
  onClose,
  onBack = onClose,
  children,
  isVisible,
}) => {
  return (
    <Drawer isOpen={isVisible} placement='right' onClose={onClose} size='lg'>
      <DrawerOverlay>
        <DrawerContent
          p={4}
          borderRadius='30px 0 0 30px'
          overflowX={'hidden'}
          height='100%'
          display='flex'
          flexDirection='column'
        >
          <IconButton
            icon={<ArrowBackIcon fontSize={30} />}
            variant='ghost'
            onClick={onBack}
            aria-label='Back'
            position='absolute'
            left={4}
            top='2rem'
            zIndex={2}
            color='var(--color-brand)'
          />
          <Box flex='1' display='flex' flexDirection='column'>
            {children}
          </Box>
        </DrawerContent>
      </DrawerOverlay>
    </Drawer>
  )
}

export default DrawerWrapper
